export const categories = [
	{
		category: '1',
		action: 'No action required',
		explanation: 'Normal and natural posture without harmful effects on the musculoskeletal system',
		color: '#2CC852'
	},
	{
		category: '2',
		action: 'Corrective actions required in the near future',
		explanation: 'Posture with the possibility of causing damage to the musculoskeletal system',
		color: '#F8D627'
	},
	{
		category: '3',
		action: 'Corrective actions are required as soon as possible',
		explanation: 'Posture with harmful effects on the musculoskeletal system',
		color: '#E74150'
	},
	{
		category: '4',
		action: 'Corrective actions need to be taken immediately',
		explanation: 'The load caused by this posture has extremely harmful effects on the musculoskeletal system',
		color: '#9B54E2'
	}
];

export function getColor(score: number, percentage?: number): string {
	if (percentage === 0) {
		return '#F8F8F8';
	}

	if (score === 1) {
		return '#2CC852';
	} else if (score === 2) {
		return '#F8D627';
	} else if (score === 3) {
		return '#E74150';
	} else if (score === 4) {
		return '#9B54E2';
	}

	return '#2CC852';
}
